import browser from"bowser";var PREFIX=browser.webkit||browser.blink?"-webkit-":browser.gecko?"-moz-":"";export default{DEFAULTS:{},CURSOR:{GRABBING:"".concat(PREFIX,"grabbing"),GRAB:"".concat(PREFIX,"grab"),POINTER:"pointer"}};
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-map-gl/dist/esm/config.js
// module id = 1507
// module chunks = 0